import { FORMAT_NAME } from './format';
import { Song } from './song';
import { Player } from '../soundtracker/player';
import { Sample } from '../soundtracker/sample';
import { Ornament } from '../soundtracker/ornament';
import { Pattern } from './pattern';

let TurbosoundtrackerEngine = {
    name: FORMAT_NAME,
    displayName: 'TurboSoundtracker',
    description: 'ZX Spectrum with TurboSound interface, 6 channels',
    Song: Song,
    Player: Player,
    Sample: Sample,
    Ornament: Ornament,
    Pattern: Pattern,
    canImport: () => {
        return false;
    },
};

export { TurbosoundtrackerEngine };
